<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-02-27 13:25:48
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<!--
Author: TangChen
Date: 2018-09-25
Desc: 安全中心页面，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-safe-center bizcomp ' + className">
        <comp-title :title="title" />
        <el-row>
            <el-col v-for="(item, index) in solveLists" :key="index" :span="22" :offset="1">
                <hint-card :data="item" v-on:btn-click="loadPage" />
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import hintCard from "@/components/layout/hintCard.vue";
export default {
    name: "ResetPwdWay",
    components: {
        hintCard
    },
    mixins: [mixin],
    data() {
        return {
            // 初始化所有操作选项配置参数
            resetWays: [
                {
                    icon: "fa fa-mobile",
                    tit: "绑定登录手机",
                    text: "绑定后可通过手机号+登录密码进行快速登录",
                    cla: "green",
                    btnArr: [{ btn: "绑定登录手机", page: "bindmobile" }]
                },
                {
                    icon: "fa fa-mobile",
                    tit: "更换登录手机",
                    text: "当前已绑定手机号，可修改绑定手机",
                    cla: "green",
                    btnArr: [{ btn: "更换登录手机", page: "checkmobile" }]
                },
                {
                    icon: "fa fa-keyboard-o",
                    tit: "修改查询密码",
                    text: "登录账户时使用的密码",
                    cla: "yellow",
                    btnArr: [{ btn: "修改查询密码", page: "changeqpwd" }]
                },
                {
                    icon: "fa fa-unlock",
                    tit: "修改登录密码",
                    text: "登录账户时使用的密码",
                    cla: "",
                    btnArr: [{ btn: "修改登录密码", page: "changelpwd" }]
                },
                {
                    icon: "fa fa-address-card",
                    tit: "绑定交易账号",
                    text: "绑定后可进行买入、卖出、定投等操作",
                    cla: "purple",
                    btnArr: [{ btn: "绑定交易账号", page: "bindacctway" }]
                },
                {
                    icon: "fa fa-key",
                    tit: "修改交易密码",
                    text: "基金交易时输入的密码，保证账户交易安全",
                    cla: "blue",
                    btnArr: [{ btn: "修改交易密码", page: "changetpwd" }]
                }
            ],
            userInfo: [
                {
                    icon: "fa fa-user",
                    tit: this.$util.getConfig().hideFunc ? "修改个人信息" : "个人信息查看",
                    text: this.$util.getConfig().hideFunc
                        ? "完善个人信息，包含身份证有效期，国籍，职业，电子邮箱等基本信息"
                        : "查看个人信息，包含身份证有效期，国籍，职业，电子邮箱等基本信息",
                    cla: "green",
                    btnArr: [
                        {
                            btn: this.$util.getConfig().hideFunc ? "修改个人信息" : "个人信息查看",
                            page: "modifyinfo"
                        }
                    ]
                },
                {
                    icon: "fa fa-pencil-square",
                    tit: this.$util.getConfig().hideFunc ? "投资者信息补录" : "投资者信息查看",
                    text: this.$util.getConfig().hideFunc
                        ? "补录投资者信息可以帮助您更好地进行理财产品的选择"
                        : "查看投资者信息可以帮助您更好地进行理财产品的选择",
                    cla: "",
                    btnArr: [
                        {
                            btn: this.$util.getConfig().hideFunc
                                ? "投资者信息补录"
                                : "投资者信息查看",
                            page: "infocollection"
                        }
                    ]
                },
                {
                    icon: "fa fa-address-card",
                    tit: this.$util.getConfig().hideFunc ? "CRS信息录入" : "CRS信息查看",
                    text: this.$util.getConfig().hideFunc
                        ? "个人税收居民身份声明信息录入，包含国籍，现居地和出生地等信息"
                        : "个人税收居民身份声明信息查看，包含国籍，现居地和出生地等信息",
                    cla: "blue",
                    btnArr: [
                        {
                            btn: this.$util.getConfig().hideFunc ? "CRS信息录入" : "CRS信息查看",
                            page: "taxeslist"
                        }
                    ]
                }
                // { icon: "fa fa-refresh", tit: "投资者转换", text: "您现在是普通投资者，可转换为专业投资者", cla: "purple", btnArr: [{ btn: "投资者转换", page: "invchange" }] },
                // { icon: "fa fa-random", tit: "绑定/解绑微信", text: "通过绑定微信账号可快速扫码进行登录", cla: "b-yellow", btnArr: [{ btn: "绑定/解绑微信", page: "wxbindchange" }] },
                // { icon: "fa fa-file-text", tit: "汇款地址信息", text: "通过汇款方式购买所需要的目标汇款账户信息", cla: "b-red", btnArr: [{ btn: "查看汇款地址信息", page: "remitinfo" }] }
            ],
            solveLists: []
        };
    },
    // 根据用户信息显示对应操作选项
    mounted() {
        if (this.$route.name === "securitycenter") {
            this.dataFilter();
        } else {
            const info = this.$cache.getUser();
            if (info.professionflag === "1" && this.userInfo[3]) {
                this.userInfo[3].text = "您现在是专业投资者，可转换为普通投资者";
            }
            if (this.$util.hideSdx()) {
                this.userInfo.splice(1, 1);
            }
            this.solveLists = this.userInfo;
        }
    },
    methods: {
        // 加载操作选项页面
        loadPage(url, way) {
            this.$router.push({ name: url });
        },
        dataFilter() {
            const info = this.$cache.getUser();
            // 手机注册用户
            if (!this.$cache.getBinded()) {
                this.solveLists = this.resetWays.filter((val) => {
                    return (
                        val.tit !== "绑定登录手机" &&
                        val.tit !== "修改交易密码" &&
                        val.tit !== "修改查询密码"
                    );
                });
            }
            // // 纯代销用户
            // if (info.usertype === "2") {
            //     this.solveLists = this.resetWays.filter((val) => {
            //         if (val.tit === "绑定交易账号") {
            //             val.btnArr[0].page = "bindnewacct";
            //         }
            //         return (
            //             val.tit !== "绑定登录手机" &&
            //             val.tit !== "修改交易密码" &&
            //             val.tit !== "更换登录手机" &&
            //             val.tit !== "修改登录密码"
            //         );
            //     });
            // }
            // 直销绑定交易账号用户
            if (this.$cache.getBinded()) {
                this.solveLists = this.resetWays.filter((val) => {
                    return (
                        (info.mobileno !== ""
                            ? val.tit !== "绑定登录手机"
                            : val.tit !== "更换登录手机" && val.tit !== "修改登录密码") &&
                        val.tit !== "绑定交易账号" &&
                        val.tit !== "修改查询密码"
                    );
                });
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-safe-center {
    padding-bottom: 30px;
    .fa-mobile {
        font-size: 50px;
    }
}
</style>
